<template>
  <div>
    <header>
      <div class="header">
        <!--Logo-->
        <div class="header-left">
          <router-link to="/index" class="logo">
            <img v-bind:src="logo" height="40" alt />
          </router-link>
        </div>
        <!--/Logo-->
        <a id="toggle_btn" href="javascript:void(0);">
          <span class="bar-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </a>
        <!-- Header Title -->
        <div class="page-title-box">
          <h3>{{ appTitle }}</h3>
        </div>
        <!-- /Header Title -->
        <a id="mobile_btn" class="mobile_btn" href="#sidebar">
          <i class="fa fa-bars"></i>
        </a>
        <!-- Header Menu -->
        <ul class="nav user-menu">
          <!-- <li class="nav-item dropdown has-arrow flag-nav">
            <a class=" nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
              <span><i title="Wa" class="text-success fa fa-plus"></i></span> Tambah
            </a>
            <div class="dropdown-menu dropdown-menu-right" v-if="isOwner">
              <router-link :title="'Tambah Kontak'" :to="'/contacts?act=add'" class="dropdown-item ">
                <i class="fa fa-user "></i> Tambah Kontak
              </router-link>
              <router-link :title="'Tambah Broadcast'" :to="'/message_report/broadcast/wizard'" class="dropdown-item ">
                <i class="fa fa-bullhorn "></i> Tambah Broadcast
              </router-link>
            </div>
          </li> -->
          <li class="nav-item dropdown has-arrow flag-nav">
            <template
              v-if="(typeof (agentSession.license_phone_number) != 'undefined' && agentSession.license_phone_number.trim() != '')">
              <a class=" nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
                <span v-if="agentSession.is_online_status == 1"><i title="Online"
                    class="text-success fa fa-signal"></i></span>
                <span v-else><i title="Offline" class="text-danger fa fa-signal"></i></span> {{
                  agentSession.license_phone_number }}</span>
              </a>
            </template>
            <template v-else>
              <a class=" nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button">
                <span><i title="Wa" class="text-success fa fa-whatsapp"></i></span> Pilih Akun
              </a>
            </template>
            <div class="dropdown-menu dropdown-menu-right" v-if="isOwner">
              <template v-if="rows.length">
                <template v-for="(row, index) in rows">
                  <router-link :ref="'isChatRoom-' + row.id"
                    :to="'/omni/connect-to-agent-owner?license_id=' + row.id + '&redirect=/copilot'"
                    class="dropdown-item" :key="index"
                    v-if="agentSession.license_phone_number != row.license_phone_number">
                    <span>
                      <span v-if="row.is_online_status == 1"><i title="Online"
                          class="text-success fa fa-signal"></i></span>
                      <span v-else><i title="Offline" class="text-danger fa fa-signal"></i></span> {{
                        row.license_phone_number }}</span>
                  </router-link>
                </template>
              </template>
              <router-link :title="'Buy an activation package'" :to="'/subscriptions'" class="dropdown-item text-info">
                <i class="fa fa-shopping-cart "></i> Tambah Nomor WA
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown has-arrow main-drop">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <span class="user-img">
                <!-- <img src="../../assets/profiles/avatar-21.jpg" alt /> -->
                <avatar :username="memberSession.email" v-if="isOwner == true"></avatar>
                <avatar :username="agentSession.first_name" v-else></avatar>
                <!-- <span class="status online"></span> -->
              </span>
              <span v-if="isOwner == true">{{ memberSession.email }}</span>
              <span v-else>{{ agentSession.first_name }}</span>
            </a>
            <div class="dropdown-menu">
              <!-- <router-link class="dropdown-item" to="/profile">My Profile</router-link> -->
              <span class="dropdown-item"
                v-if="(typeof (agentSession.license_phone_number) != 'undefined' && agentSession.license_phone_number.trim() != '' && agentSession.is_unlimited == 0)">
                No. WA: {{ agentSession.license_phone_number }}<br />
                Masa Aktif: {{ agentSession.license_masa_aktif }}
                <span v-if="agentSession.status_label == 'Expired'" class="text-danger"><br /><b>Expired</b></span>

                <center> <router-link :title="'Buy an activation package'"
                    class="btn btn-primary btn-sm btn-outline-lime"
                    :to="'/subscriptions?license_id=' + agentSession.license_id">
                    <i class="fa fa-shopping-cart"></i> Renewal
                  </router-link></center>
                <hr style="margin:1px;" />
              </span>
              <router-link class="dropdown-item"
                :to="'/license/list?license_phone_number=' + agentSession.license_phone_number"
                v-if="isOwner == true"><i class="fa fa-qrcode"></i> {{ agentSession.license_phone_number
                }}</router-link>
              <router-link class="dropdown-item" to="/settings" v-if="isOwner == true">Settings</router-link>
              <a class="dropdown-item" href="javascript:void(0)" @click="logout">Logout</a>
            </div>
          </li>
        </ul>
        <!-- Mobile Menu -->
        <div class="dropdown mobile-user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <!-- <router-link class="dropdown-item" to="/profile">My Profile</router-link> -->
            <span class="dropdown-item" href="javascript:void(0)"
              v-if="(typeof (agentSession.license_phone_number) != 'undefined' && agentSession.license_phone_number.trim() != '')">
              No. WA: <span v-if="agentSession.is_online_status == 1"><i title="Online"
                  class="text-success fa fa-signal"></i></span>
              <span v-else><i title="Offline" class="text-danger fa fa-signal"></i></span>
              {{ agentSession.license_phone_number }}<br />
              <template v-if="agentSession.is_unlimited == 0">Masa Aktif: {{ agentSession.license_masa_aktif }}
                <span v-if="agentSession.status_label == 'Expired'" class="text-danger"><b>Expired</b></span>
                <center> <router-link :title="'Buy an activation package'"
                    class="btn btn-primary btn-sm btn-outline-lime"
                    :to="'/subscriptions?license_id=' + agentSession.license_id">
                    <i class="fa fa-shopping-cart"></i> Renewal
                  </router-link></center>
              </template>
              <hr style="margin:1px;" />
            </span>
            <router-link class="dropdown-item"
              :to="'/license/list?license_phone_number=' + agentSession.license_phone_number" v-if="isOwner == true"><i
                class="fa fa-qrcode"></i> {{ agentSession.license_phone_number }}</router-link>
            <router-link class="dropdown-item" to="/settings">Settings</router-link>
            <a class="dropdown-item" href="javascript:void(0)" @click="logout">Logout</a>
          </div>
        </div>
      </div>
      <impersonation-banner></impersonation-banner>
    </header>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Avatar from 'vue-avatar'
import ImpersonationBanner from '@/components/layouts/ImpersonationBanner.vue'

export default {
  components: {
    Avatar,
    ImpersonationBanner
  },
  data() {
    return {
      serverParams: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 1000
      },
      rows: [],
      totalRecords: 0,
      isLoading: false,
      isDisabled: 0,
      appTitle: process.env.VUE_APP_TITLE,
      logo: process.env.VUE_APP_LOGO,
      logoText: process.env.VUE_APP_LOGO_TEXT
    };
  },
  computed: {
    ...mapGetters(["agentSession", "rolesMember", "SCAN_QRCODE_Data", "logoutCounter"]),
    isOwner() {
      if (typeof this.agentSession.is_owner == "undefined") {
        return true;
      } else {
        if (this.agentSession.is_owner == 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    memberSession() {
      return this.$store.state.login.memberSession;
    }
  },
  watch: {
    SCAN_QRCODE_Data(val) {
      if (
        val &&
        typeof val.status != "undefined" &&
        (val.status == 1 || val.status == 0)
      ) {
        this.checkOnlineStatus();
      }
    },
    logoutCounter() {
      this.checkOnlineStatus();
    }
  },
  created() {
    this.getLicense()
    // console.log("agentSession", this.agentSession)
  },
  methods: {
    async getLicense() {
      this.isLoading = true;
      await this.$store
        .dispatch("license/getLicenseList", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.rows = data.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
      this.checkOnlineStatus();
    },
    async checkOnlineStatus() {
      this.rows.forEach(async (row, index) => {
        await this.isOnline(row);
      });
    },
    async isOnline(row) {
      if (!row.license_phone_number) {
        return;
      }
      await this.$store
        .dispatch("omniwa/isOnline", row.license_phone_number)
        .then(response => {
          var { data } = response;
          row.is_online_status = data.status === 1 ? 1 : 0;
        })
        .catch(error => {});
    },
    async logout() {
      var that = this;
      await this.$fire({
        title: "Do you want to logout?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("login/logout", this.fields) // sesuai kan dengan method di API
            .then(response => {
              // console.log("response", response);
            })
            .catch(error => {
              this.isDisabled = 0;
            });

          await this.$router.push("/login");
        }
      });
      // this.$confirm("Are you sure?").then(e => {
      //   //do something...
      //   console.log("e", e);
      // });
      // this.$alert("Are you sure want to logout?").then(() => {
      //   //do something...
      //   // this.$store
      //   //   .dispatch("login/logout", this.fields) // sesuai kan dengan method di API
      //   //   .then(response => {
      //   //     console.log("response", response);
      //   //     if (response["status"] == 200) {
      //   //       this.$fire({
      //   //         title: "Success",
      //   //         text: response["msg"],
      //   //         type: "success",
      //   //         timer: 1000
      //   //       }).then(r => {
      //   //         //   console.log(r.value);
      //   //         //redirect to login form
      //   //         this.$router.push("/login");
      //   //       });
      //   //     }
      //   //   })
      //   //   .catch(error => {
      //   //     this.$router.push("/login");
      //   //   });
      // });
    }
  },
  mounted() {
    // Variables declarations
    var $wrapper = $(".main-wrapper");

    // $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      // $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });
    $(".sidebar-overlay").on("click", function () {
      $("html").removeClass("menu-opened");
      $(this).removeClass("opened");
      $wrapper.removeClass("slide-nav");
      // $(".sidebar-overlay").removeClass("opened");
      $("#task_window").removeClass("opened");
    });

    $(document).on("click", ".top-nav-search .responsive-search", function () {
      $(".top-nav-search").toggleClass("active");
    });
    $(".sidebar-menu ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/layouts/Header.vue